import React, { useEffect } from 'react';
import { useConfirmDialog } from '../../contexts/ConfirmDialogContext';

const ServiceWorkerUpdateListener: React.FC = () => {
  const { confirm } = useConfirmDialog();

  useEffect(() => {
    const handler = (event: Event) => {
      const ev = event as CustomEvent<{ registration?: ServiceWorkerRegistration }>;
      const registration = ev.detail?.registration;
      if (!registration) return;
      (async () => {
        const ok = await confirm({
          title: 'Aktualizace aplikace',
          message: 'Nová verze aplikace je k dispozici. Chcete aktualizovat?',
          confirmText: 'Aktualizovat',
          cancelText: 'Později',
        });
        if (ok && registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          window.location.reload();
        }
      })();
    };
    window.addEventListener('sw-update-available', handler as EventListener);
    return () => {
      window.removeEventListener('sw-update-available', handler as EventListener);
    };
  }, [confirm]);

  return null;
};

export default ServiceWorkerUpdateListener;
